import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <i className="fas fa-birthday-cake"></i>
              <span>Bubu’s Sweet Treats</span>
            </div>
            <p>Delicious cakes, pastries and bespoke event decors made with love. Serving Akwakuma and the surrounding communities.</p>
            <div className="social-links">
              <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="#" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Our Offerings</h4>
            <ul>
              <li><a href="#services">Custom Cakes</a></li>
              <li><a href="#services">Pastries & Bread</a></li>
              <li><a href="#services">Event Decorations</a></li>
              <li><a href="#contact">Order & Delivery</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <span>No 100 Orlu Road, Akwakuma, Imo State</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <span>08164810794, +234 705 992 0558</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <span>info@bubussweettreats.com</span>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Bubu’s Sweet Treats. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;